import { createContext, createElement } from "react";

export interface MessageType {
  img: string;
  title_bgcolor: string;
}

export interface vMsgProps {
    title: string;
    sub_title: string;
    content: JSX.Element;
    iMsg: number;
    bBtnType: boolean;
    submitFun: () => void;
}

export const initMessageProps: vMsgProps = {
  title: "",
  sub_title: "",
  content: createElement('span'),
  iMsg: 0,
  bBtnType: true,
  submitFun: () => {},
}

const MessageContext = createContext({
  alertProps: initMessageProps,
  setIsAlert: (x: boolean): void => {},
  setAlertProps: (content: vMsgProps): void => {},
});

export const { Provider, Consumer } = MessageContext;

export default MessageContext;
